import { isServer } from './env-helper';
import { map } from './map';

export const SessionStorageKey = {
  ReferrerPath: 'FLIPSTER_REFERRER_PATH',
  ReferralCode: 'FLIPSTER_REFERRAL_CODE',
  ReferralType: 'FLIPSTER_REFERRAL_TYPE',
  IpTempHash: 'FLIPSTER_IP_TEMP_HASH',
  AuthErrorMessage: 'FLIPSTER_AUTH_ERROR_MESSAGE',
  SignUpFloatingIconClosed: 'FLIPSTER_SIGN_UP_FLOATING_ICON_CLOSED',
} as const;

export interface SessionStorageValue {
  [SessionStorageKey.ReferrerPath]: string;
  [SessionStorageKey.ReferralCode]: string;
  [SessionStorageKey.ReferralType]: string;
  [SessionStorageKey.IpTempHash]: string;
  [SessionStorageKey.AuthErrorMessage]: string;
  [SessionStorageKey.SignUpFloatingIconClosed]: boolean;
}

export const getSessionStorage = <K extends keyof SessionStorageValue>(
  key: K,
  withDelete: boolean = false,
): SessionStorageValue[K] | null => {
  if (isServer) return null;
  const value = sessionStorage?.getItem(key);
  if (withDelete) sessionStorage?.removeItem(key);
  try {
    return map(value, JSON.parse) as SessionStorageValue[K] | null;
  } catch {
    // fallback - previous value before implement serde or invalid value
    return value as SessionStorageValue[K] | null;
  }
};

export const setSessionStorage = <K extends keyof SessionStorageValue>(key: K, value: SessionStorageValue[K]) => {
  sessionStorage?.setItem(key, JSON.stringify(value));
};

export const deleteSessionStorage = (key: keyof SessionStorageValue) => {
  sessionStorage?.removeItem(key);
};

export const getReferralInfo = () => {
  const referralCode = getSessionStorage(SessionStorageKey.ReferralCode);
  const referralType = getSessionStorage(SessionStorageKey.ReferralType);
  return {
    referral_code: referralCode ?? null,
    referral_type: referralType ?? null,
  };
};
